<template>
  <div class="home">
    <img
      class="banner"
      src="../assets/img/index/banner1.png"
    />
    <!----------方案开始------------->
    <div class="fa-title">免费获取资金方案</div>
    <div class="fa">
      <div class="fa-div">
        <img style="width:1.3rem;" src="../assets/img/index/icon_user3.png"/>
        <van-field
        style="border-radius: 2rem;"
          v-model="model.customer_name"
          clearable
          placeholder="请输入姓名"
        />
      </div>
      
      <div class="fa-div mt">
        <img  src="../assets/img/index/icon_phone3.png"/>
        <van-field
        type="tel"
        style="margin-left:0.3rem;border-radius: 2rem;"
          v-model="model.phone"
          clearable
          placeholder="请输入手机号"
        />
      </div>

      <div class="fa-div-yzm mt">
        <div class="fa-div" style="flex: 1;">
          <img style="width:1.3rem;" src="../assets/img/index/icon_shield3.png"/>
          <van-field
          type="number"
          style="border-radius: 2rem;"
            v-model="model.sms"
            maxlength="6"
            clearable
            placeholder="请输入验证码"
          />
        </div>
        <van-button @click="clickSms()" style="width:10rem;margin-left:1rem;background-color:#3a8af2" round type="primary">{{data.smstxt}}</van-button>
      </div>
      <div class="fa-div-radio mt">
        <div @click="changeFlagCompany('1')" class="fa-radio">
          <div v-if="model.flag_company=='1'" class="fa-sel"></div>
        </div>
        <div @click="changeFlagCompany('1')" class="fa-label">名下有公司</div>

        <div @click="changeFlagCompany('0')" class="fa-radio" style="margin-left:1rem;">
          <div v-if="model.flag_company=='0'"  class="fa-sel"></div>
        </div>
        <div @click="changeFlagCompany('0')" class="fa-label">名下没有公司</div>
      </div>

      <div class="hr mt" style="margin-left:1rem;margin-right:1rem;"></div>
      <div class="fa-div-radio" style="margin-top:0.5rem;">
        <div class="fa-chk">
          <img @click="changeChk('1')" v-if="model.chk!='1'" src="@/assets/img/index/icon_check.png"/>
          <img @click="changeChk('0')" v-if="model.chk=='1'" src="@/assets/img/index/icon_check_sel.png"/>
        </div>
        <div class="fa-label-xy">我已阅读并同意<a @click="clickXy(1)">《用户协议》</a>、<a  @click="clickXy(2)">《隐私协议》</a>及<a @click="clickXy(3)">《内容平台协议》</a></div>
      </div>
      <div class="mt" style="margin-right:1.2rem;">
        <van-button @click="clickFa()" class="mt fa-btn" style="margin-left:1rem;background-color:#C90000;" size="large" round type="danger">点击获取您的专属资金方案</van-button>
      </div>
    </div>
    <!----------方案介绍------------->

    <!----------近期客户开始------------->
    <div class="customer">
      <div class="customer-title">
        <img style="width:1.3rem;" src="../assets/img/index/icon_fire.png"/>
        <div class="customer-label">
            已有<a>{{data.nums}}</a>人申请
        </div>
      </div>
      <div class="customer-title-sub">
        最新参与客户
      </div>

   <div class="customer-con">
<van-swipe class="my-swipe" :autoplay="3000" :touchable="false" :loop="true" :show-indicators="false" vertical>
  <van-swipe-item :key="item.phone" v-for="(item,index) in data.sclist1">
        <div :class="'customer-con-div '+(index==2?'':'')">
          <div class="customer-con-div-name">
            <img src="../assets/img/index/icon_bell_sel.png"/>
            <div>{{item.name}}</div>
          </div>
          <div class="lineh"></div>
          <div class="customer-con-div-phone">{{item.phone}}</div>
          <div class="lineh"></div>
          <div class="customer-con-div-time">{{item.time}}</div>
        </div>
  </van-swipe-item>
  
</van-swipe>

<div class="customer-con-div-bg">
<van-swipe class="my-swipe" :autoplay="3000" :touchable="false" :loop="true" :show-indicators="false" vertical>

  <van-swipe-item :key="item.phone" v-for="(item) in data.sclist2" style="border-radius:1.3rem">
        <div :class="'customer-con-div'" style="color:#5000A0;border-radius: 1.3rem;">
          <div class="customer-con-div-name">
            <img src="../assets/img/index/icon_bell_sel.png"/>
            <div>{{item.name}}</div>
          </div>
          <div class="lineh"></div>
          <div class="customer-con-div-phone">{{item.phone}}</div>
          <div class="lineh"></div>
          <div class="customer-con-div-time">{{item.time}}</div>
        </div>
  </van-swipe-item>

</van-swipe>
</div>

<van-swipe class="my-swipe" :autoplay="3000" :touchable="false" :loop="true" :show-indicators="false" vertical>
  <van-swipe-item :key="item.phone" v-for="(item,index) in data.sclist3">
        <div :class="'customer-con-div '+(index==2?'':'')">
          <div class="customer-con-div-name">
            <img src="../assets/img/index/icon_bell_sel.png"/>
            <div>{{item.name}}</div>
          </div>
          <div class="lineh"></div>
          <div class="customer-con-div-phone">{{item.phone}}</div>
          <div class="lineh"></div>
          <div class="customer-con-div-time">{{item.time}}</div>
        </div>
  </van-swipe-item>
  
</van-swipe>

<van-swipe class="my-swipe" :autoplay="3000" :touchable="false" :loop="true" :show-indicators="false" vertical>
  <van-swipe-item :key="item.phone" v-for="(item,index) in data.sclist4">
        <div :class="'customer-con-div '+(index==2?'':'')">
          <div class="customer-con-div-name">
            <img src="../assets/img/index/icon_bell_sel.png"/>
            <div>{{item.name}}</div>
          </div>
          <div class="lineh"></div>
          <div class="customer-con-div-phone">{{item.phone}}</div>
          <div class="lineh"></div>
          <div class="customer-con-div-time">{{item.time}}</div>
        </div>
  </van-swipe-item>
  
</van-swipe>




</div>
    </div>
        

 
  
    <!----------近期客户结束------------->

    <!----------服务优势开始------------->
    <div class="service">
      <div class="service-title">服务优势</div>
      <div class="service-con">
        <div class="service-item bg1">
          <img src="../assets/img/index/icon_company.png"/>
          <div class="service-item-title">
            <div class="title1">企业经营周转</div>
            <div class="title2">近一年纳税/流水/发票</div>
          </div>
        </div>

        <div class="service-item bg2 ml">
          <img src="../assets/img/index/icon_people2.png"/>
          <div class="service-item-title">
            <div class="title1">个人消费急用</div>
            <div class="title2">三步申请 即可拿钱</div>
          </div>
        </div>
      </div>
      <div class="service-con" style="margin-top:0.5rem;">
        <div class="service-item bg3">
          <img src="../assets/img/index/icon_flow1.png"/>
          <div class="service-item-title">
            <div class="title1">流程简单</div>
            <div class="title2">资料少审批快</div>
          </div>
        </div>

        <div class="service-item bg4 ml">
          <img src="../assets/img/index/icon_lock1.png"/>
          <div class="service-item-title">
            <div class="title1">安全放心</div>
            <div class="title2">银行机构放款</div>
          </div>
        </div>
      </div>
      <div class="service-title2">款小满 · 满足您的款款而来</div>
      <div class="service-title3">额度高 放款快 利率低 周期长</div>
    </div>
    <!----------服务优势结束------------->

    <!----------菜单开始------------->
    <!-- <Menu :emodel="menuIndex"></Menu> -->
    <!----------菜单结束------------->

    <!-- <div style="height:100px;"></div> -->
  </div>
</template>

<script setup>
import {} from 'vant';
import {ref,reactive,computed,watch,markRaw,defineProps,defineExpose} from "vue"
// import Menu from '../components/Menu.vue'
import {useRoute,useRouter} from 'vue-router'
import api from '../common/http.js';
import {isNull,nullStr,showMessage,getInTimes,getStopTimes} from '../common/utils.js'
import { useStore } from 'vuex'
const store = useStore()
store.commit('setTitle1','款小满 · 满足您的款款而来')
store.commit('setTitle2','额度高 放款快 利率低 周期长')

let route=useRoute()
let router=useRouter()
// let menuIndex={index:1}
getInTimes();

function clickXy(code){
  router.push({ path: '/xy',query:{"newsCode":code} })
}

let data=reactive({
    smstxt:"获取验证码",
    time:0,
    timer:'',
    nums:localStorage.getItem("num")?localStorage.getItem("num"):3968,
    ntimer:'',
    sclist1:[
      {name:"刘**",phone:"135****8794","time":"刚刚"},
      {name:"王**",phone:"151****8097","time":"1分钟前"},
      {name:"赵**",phone:"137****7601","time":"5分钟前"},
      {name:"李**",phone:"136****3301","time":"7分钟前"}
    ],
    sclist2:[
      {name:"王**",phone:"151****8097","time":"1分钟前"},
      {name:"赵**",phone:"137****7601","time":"5分钟前"},
      {name:"李**",phone:"136****3301","time":"7分钟前"},
      {name:"刘**",phone:"135****8794","time":"刚刚"},
    ],
    sclist3:[
      {name:"赵**",phone:"137****7601","time":"5分钟前"},
      {name:"李**",phone:"136****3301","time":"7分钟前"},
      {name:"刘**",phone:"135****8794","time":"刚刚"},
      {name:"王**",phone:"151****8097","time":"1分钟前"},
    ],
    sclist4:[
      {name:"李**",phone:"136****3301","time":"7分钟前"},
      {name:"刘**",phone:"135****8794","time":"刚刚"},
      {name:"王**",phone:"151****8097","time":"1分钟前"},
      {name:"赵**",phone:"137****7601","time":"5分钟前"},
    ]
})

function numAdd(){
  let a = Math.random();
  //随机生成的数字 0-1之间
  //乘以6之后 0-7之间
  let b = a * 6
  // 向下取整
  let c = Math.floor(b)
  let nums=3968;
  if(localStorage.getItem("num")){
    nums=parseInt(localStorage.getItem("num"));
  }
  nums=nums+c;
  data.nums=nums;
  localStorage.setItem("num",nums);
}

if(data.ntimer){
  clearInterval(data.ntimer)
}
data.ntimer= setInterval(numAdd, 2000);

let model=reactive({
   p0_times:getStopTimes(),
  popularize_code:nullStr(route.query.code),
    customer_name:"",
    phone:"",
    sms:"",
    flag_company:"",
    chk:'0'
})
function changeChk(flag){
  model.chk=flag;
}
//修改是否有公司
function changeFlagCompany(flag){
  model.flag_company=flag;
}
//获取短信验证码
function sms(){
    data.time--;
    data.smstxt='重新获取('+data.time+'s)';
    if(data.time == 0){
        clearInterval(data.timer);
        data.smstxt='重新获取';
    }
}

function clickSms(){
  if(isNull(model.customer_name)){
    showMessage("请输入姓名");
    return;
  }
  if(isNull(model.phone)){
    showMessage("请输入手机号");
    return;
  }
  if(data.time>0){
    return;
  }
  api.post("/web/sms/sms",model).then((res)=>{
        if(res.errcode=="0"){
          data.time=60;
          data.timer = setInterval(sms, 1000);
        }else{
          showMessage(res.errmsg);
        }
  })
  
}

function clickFa(){
  if(isNull(model.customer_name)){
    showMessage("请输入姓名");
    return;
  }
  if(isNull(model.phone)){
    showMessage("请输入手机号");
    return;
  }
  if(isNull(model.sms)){
    showMessage("请输入验证码");
    return;
  }
  if(isNull(model.flag_company)){
    showMessage("请选择是否有公司");
    return;
  }
  if(model.chk!="1"){
    showMessage("请阅读并同意协议");
    return;
  }
  model.p1_times=getStopTimes();
  api.post("/web/customer/customersave",model).then((res)=>{
        console.log(JSON.stringify(res))
        if(res.errcode=="0"){
          localStorage.clear();
          localStorage.setItem("token",res.token);
          localStorage.setItem("name",res.name);
          localStorage.setItem("userType","06");
          var levelmap={};
          for(var i=0;i<res.levellist.length;i++){
            var item=res.levellist[i];
            levelmap[item.level_commission]=item;
          }
          localStorage.setItem("levelmap",JSON.stringify(levelmap));
          
          var customerCode=res.customerCode;
          router.push({ path: '/schemeadd',query:{"customerCode":customerCode} })
        }else{
          showMessage(res.errmsg);
        }
  })

  
}
</script>
<style scoped lang="scss">
.my-swipe{
  height: 3rem;
  .van-swipe-item {
  height:3rem;
    // color: #fff;
    // font-size: 20px;
    // line-height: 150px;
    // text-align: center;
    // background-color: #39a9ed;
  }
}


.banner{
  width:100%;
  height:auto;
}
.service{
  .ml{
    margin-left:0.5rem;
  }
  .service-con{
    display: flex;
    margin-left:2rem;
    margin-right:2rem;
    
    .service-item{
      &.bg1{
        background: url(../assets/img/index/service_company.png);
        background-size: 100% 100%;
      }
      &.bg2{
        background: url(../assets/img/index/service_people.png);
        background-size: 100% 100%;
      }
      &.bg3{
        background: url(../assets/img/index/service_flow.png);
        background-size: 100% 100%;
      }
      &.bg4{
        background: url(../assets/img/index/service_lock.png);
        background-size: 100% 100%;
      }
      flex:1;
      
      border-radius: 1rem;
      display: flex;
      height: 5rem;
      align-items:center;
      img{
        margin-left:1rem;
        width: 2rem;
        height: 2rem;
      }
      .service-item-title{
        margin-left: 0.5rem;
        .title1{
          font-size: 0.9rem;
          font-weight: bold;
        }
        .title2{
          font-size: 0.6rem;
          color: grey;
        }
      }
      // background: url(@/assets/img/index/service_company.png);
    }
  }
  .service-title{
    text-align: center;
    color: #0071BC;
    line-height: 2rem;
    align-items: center;
    font-weight: 500;
    margin-left: 1rem;
    font-size: 1.1rem;
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .service-title2{
    text-align: center;
    color: #848E9D;
    line-height: 2rem;
    align-items: center;
    font-weight: 500;
    margin-left: 1rem;
    font-size: 1.1rem;
    margin-top: 4rem;
  }

  .service-title3{
    text-align: center;
    color: #949999;
    line-height: 2rem;
    align-items: center;
    margin-left: 1rem;
    font-size: 0.9rem;
    margin-bottom: 2rem;
  }
}

.customer{
  .customer-con{
    margin:1rem;
    margin-left:2rem;
    margin-right:2rem;
     .customer-con-div-bg{
        color:#5000A0;
        background: #DCCCEC;
        border-radius: 1.3rem;
     }
    .customer-con-div{
      height:1.8rem;
      padding: 0.5rem;
      display: flex;
      justify-items: center;
      justify-content: center;
      line-height:1.8rem;
      color:#DCCCEC;
      
      .customer-con-div-name{
        display: flex;
        justify-content: center;
        justify-items: center;
        flex: 2;
        img{
          height: 1.4rem;
          margin-top:0.2rem;
        }
        div{
          vertical-align: middle;
          margin-left: 0.5rem;
        }
      }
      .customer-con-div-phone{
        justify-items: center;
        justify-content: center;
        display: flex;
        flex: 3;
      }
      .customer-con-div-time{
        text-align: center;
        vertical-align: middle;
        flex: 2;
      }

      &.on{
        color:#5000A0;
        background: #DCCCEC;
        border-radius: 1.3rem;
        .lineh{
          margin-top: 0.4rem;
          width:1px;
          height: 1rem;
          background: #5000A0;
        }
      }
    }
  }
  .customer-title-sub{
    text-align: center;
    color: #5000A0;
    line-height: 2rem;
    align-items: center;
    font-weight: 500;
    margin-left: 1rem;
    font-size: 1.1rem;
    margin-top: 2rem;
  }
  .customer-title{
    margin-top:2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    .customer-label{
      color: #5000A0;
      line-height: 2rem;
      align-items: center;
      font-weight: 500;
      margin-left: 1rem;
      font-size: 1.1rem;
      a{
        // background: blue;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
        padding-top: 0.2rem;
        padding-bottom: 0.2rem;
        margin-left: 0.2rem;
        margin-right: 0.2rem;
        color: #fff;
        border-radius: 0.3rem;
        font-size:1.3rem;
        background: -webkit-linear-gradient(left top, #5000A0 , #0071BC); /* Safari 5.1 - 6.0 */
        background: -o-linear-gradient(bottom right, #5000A0, #0071BC); /* Opera 11.1 - 12.0 */
        background: -moz-linear-gradient(bottom right, #5000A0, #0071BC); /* Firefox 3.6 - 15 */
        background: linear-gradient(to bottom right, #5000A0 , #0071BC); /* 标准的语法 */
      }
    }
  }
}

.fa-title{
  margin:auto;
  text-align: center;
  font-size: 1.2rem;
  color: #225fb1;
}
.fa{
  margin: 1.2rem;

  .fa-btn{
    
  }
  .mt{
    margin-top:0.5rem;
  }
  .fa-div{
    border: 1px solid #949999;
    border-radius: 2rem;
    padding-left: 1rem;
    padding-right: 1rem;
    display: flex;
    align-items:center;
    img{
      width: 1rem;
      height: 1.3rem;
      vertical-align: middle;
    }
  }

  .fa-div-yzm{
    display: flex;
  }
  .fa-chk{
    img{
      width:1rem;
    }
  }

  .fa-div-radio{
    margin-top:1rem;
    padding-left:1rem;
    display: flex;
    align-items: center;
    .fa-radio{
      width:0.8rem;
      height:0.8rem;
      border: 1px solid #ddd;
      border-radius: 50%;
      .fa-sel{
        width:0.6rem;
        height:0.6rem;
        margin:0.1rem;
        border-radius: 50%;
        background: #4372f6;
      }
    }
    .fa-label{
      font-size: 0.9rem;
      margin-left: 0.5rem;
      color:#0A1E3C;
    }
    .fa-label-xy{
      font-size: 0.7rem;
      margin-left: 0.5rem;
      color:#afb4bd;
      a{
        color:#3D6FFF;
      }
    }

     
  }

  .hr{
    background: #ddd;
    height:1px;
  }

  .van-field__control{
    margin-left: 0.5rem;
  }
}
</style>
